import React from 'react';
import ManagerHeader from '../components/ManagerHeader';
import ManagerSidebar from '../components/ManagerSidebar';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Manager: React.FC = () => {
  const donationData = [
    { date: '01/10', quantity: 5, revenue: 100 },
    { date: '02/10', quantity: 8, revenue: 150 },
    // ... more data points ...
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <ManagerHeader />

      <div className="flex flex-col md:grid md:grid-cols-[180px_1fr] min-h-screen">
        <ManagerSidebar />

        <section className="w-full bg-white p-4 md:p-6 rounded-sm">
          <div className="mb-6 text-center">
            <h2 className="text-xl md:text-3xl font-semibold text-brown-800 text-gradient">Olá, bom dia Bruno Darolt</h2>
            <p className="text-gray-600 mt-2 text-brown-600">Que o Senhor te abençoe hoje. "Buscai primeiro o Reino de Deus e a sua justiça."</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="card">
              <h3 className="text-xl font-semibold mb-4">Quantidade de Doações - Últimos 30 Dias</h3>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={donationData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="quantity" stroke="#b76e17" activeDot={{ r: 8 }} strokeWidth={3} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="card">
              <h3 className="text-xl font-semibold mb-4">Receita de Doações - Últimos 30 Dias</h3>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={donationData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="revenue" stroke="#b07b3b" strokeWidth={3} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Manager;


